import { render } from "./AddressSidebarPlaceholder.vue?vue&type=template&id=9d61a362&scoped=true&ts=true"
import script from "./AddressSidebarPlaceholder.vue?vue&type=script&lang=ts"
export * from "./AddressSidebarPlaceholder.vue?vue&type=script&lang=ts"

import "./AddressSidebarPlaceholder.vue?vue&type=style&index=0&id=9d61a362&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d61a362"]])

export default __exports__